import React, { useState } from 'react';
import { Section, FadeIn } from './ui';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'Is Offsite+ an event registration tool?',
    a: 'No. It is the experience layer. It works alongside registration, hotel, CRM, and planning tools.'
  }, {
    q: 'Do attendees need to download an app?',
    a: 'No. The experience can work through a simple web-based event hub.'
  }, {
    q: 'Is this only for luxury retreats?',
    a: 'No. It works for hotels, resorts, training days, leadership retreats, conferences, and mid-market group meetings.'
  }, {
    q: 'Does AI run the event?',
    a: 'No. AI helps design the structure. The planner stays in control.'
  }, {
    q: 'Can hotels and DMCs white-label it?',
    a: 'Yes. Partner plans support white-label event hubs and reusable templates.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-slate-50" data-id="element-2678">
      <div className="max-w-3xl mx-auto" data-id="element-2679">
        <FadeIn className="text-center mb-12" data-id="element-2680">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-2681">
            Frequently Asked Questions
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-2682">
          {faqs.map((faq, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-2683">
              <div className="bg-white border border-slate-200 rounded-xl overflow-hidden hover:border-brand-teal/50 transition-colors" data-id="element-2684">
                <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-2685">
                  <span className="font-bold text-brand-navy pr-8" data-id="element-2686">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === i ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-2687">
                    <ChevronDownIcon className="w-5 h-5 text-slate-400" data-id="element-2688" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-2689">
                  {openIndex === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-2690">
                      <div className="px-6 pb-6 text-slate-600 border-t border-slate-50 pt-4" data-id="element-2691">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </Section>;
}